<template>
  <div class="ContinueBox">
    <div class="top_jiant1"></div>
    <div class="ContinueHeade">
      <div class="title1">
        高级图片编辑
      </div>
      <div class="ContRightHeade">
        <div class="version-selector"
             @mouseover="showTooltip(true)"
             @mouseleave="showTooltip(false)">
          <div>
            版本选择：
          </div>
          <div class="ver">
            {{ RevisionWin == 'v2.5' ? 'G2.5版' : 'G3.0版' }} <img src="./img/018.png" alt="">
          </div>
          <div class="version-info" v-if="RevisionShow">
<!--            <div class="version-info">-->
            <div class="ver_info">
              <div :class="['ver_List',vernum==0?'one':'']"
                   v-for="(vertext,vernum) in versions"
                   @click="hideTooltip(vertext,vernum)">
                <div :class="['ver_type',RevisionWin==vertext.model_version1?'yes':'no']">
                  {{ vertext.type }} <img v-if="RevisionWin==vertext.model_version1"
                                          src="./img/020.png" alt="">
                </div>
                <div class="ver_jfbox">
                  <div class="ver_name">{{ vertext.name }}</div>
                  <div class="verJF">{{ vertext.jf }}</div>
                </div>
              </div>
            </div>
            <div class="version_btn" @click="showTooltip(false)">
              好的，我知道了
            </div>
          </div>
        </div>
        <div class="demonstration" @click="ShowContinue()">
          视频演示
        </div>
      </div>
    </div>
    <div class="ContinueBody">
      <textarea v-if="site=='left'"
          class="compile"
          v-model="prompt1"
          placeholder="请输入修改上方图片的高级编辑描述，多个要求请用“，”隔开"
          rows="5">
      </textarea>
      <textarea v-else
          class="compile"
          v-model="prompt2"
          :placeholder="ListItem.pic_num==4?'请针对上方图一（默认）、图二、图三、图四输入高级图片修改编辑命令，多个命令用“，”隔开':'请输入修改上方图片的高级编辑描述，多个要求请用“，”隔开'"
          rows="5">
      </textarea>
      <div class="beginBtn" v-loading="btnloading"
           @click="beginBtn(ListItem)">
        开始编辑
      </div>
    </div>
    <canvas ref="localCanvas" style="display: none;" useCORS="true" allowTaint="true"></canvas>
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>

<script type="text/ecmascript-6">
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from "@/utils";

export default {
  components: {faceVerifyPopup},
  props: [
    'ListItem', // 数据信息
    'site', // 判断是那张图
    'drawtype', //  那个模型列表
    'btntype', //  那个按钮模块
  ],
  data(){
    return {
      fileApi: FILE_API_SERVER,
      btnloading:false,
      prompt1:'',
      prompt2:'',
      captureUrl:'',
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    versions() {
      return this.$store.state.versions
    },
    RevisionShow() {
      return this.$store.state.RevisionShow
    },
    RevisionWin() {
      return this.$store.state.RevisionWin
    },
  },
  methods: {
    getProfile() {
      this.$http.get(`/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
        }
      }).finally(() => {
      })
    },
    // beginBtn(item) {
    //   let place = 1
    //   this.zhuanhuan(item,place)
    // },
    async beginBtn(item) {
      console.log('开始高级编辑')
      console.log(item)
      try {
        if (!this.checkLogin()) return
        if(SITE_BTN_CONFIG[this.btntype].btn_state==0){
          if(this.userInfo.is_vip==0){
            utils.createErrTip('no_open_vip')
          }else{
            if(this.userInfo.is_vip_end==1){
              utils.createErrTip('vip_expire')
            }else{
              this.$store.commit('setTechnical_Show',true)
            }
          }
          return;
        }
        if (this.userInfo.is_vip == 0 || this.userInfo.is_vip_end != 0) {
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        }
        if( this.site=='left'){
          if (this.prompt1.trim() == '') {
            this.$message.warning('请输入高级描述词！')
            return;
          }
        }else{
          if (this.prompt2.trim() == '') {
            this.$message.warning('请输入高级描述词！')
            return;
          }
        }
        let place
        if(item.pic_num==4){
          if(this.prompt2.includes('图一')){
            place = 1
          }else if(this.prompt2.includes('图二')){
            place = 2
          }else if(this.prompt2.includes('图三')){
            place = 3
          }else if(this.prompt2.includes('图四')){
            place = 4
          }else{
            this.prompt2 = this.prompt2+'，图一'
            place = 1
          }
          // this.zhuanhuan(item,place)
          const base64 = await this.zhuanhuan(item, place) // 裁剪完成
          const uploadRes = await this.uploadBase64(base64)
          console.log('uploadRes')
          console.log(uploadRes)
        }
        console.log('this.captureUrl',)
        console.log(this.captureUrl)
        let formData = {
          data: {model_version: this.RevisionWin},
          iw_url: this.site=='left'? item.iw_url : item.pic_num==4?this.captureUrl:item.img_url,
          prompt: this.site=='left'? this.prompt1 : this.prompt2,
          parent_draw_id: item.draw_id,
          soft: this.drawtype,
        }
        console.log(formData)
        // return;
        this.btnloading = true

        this.$http.post('/front/aimj/edit/', formData).then(res => {
          if (res.status == 200) {
            this.prompt1 = ''
            this.prompt2 = ''
            this.getProfile()
            this.$emit('success',res.data)
          } else {
          }
        }).catch(res => {
          let message = res.message;
          this.draw_list.splice(0, 1)
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // this.$router.push('/member')
              this.$store.commit('setisPayPopShow', true)
            }).catch(() => {
            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // this.$router.push('/member')
              this.$store.commit('setisPayPopShow', true)
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // this.$router.push('/member')
              this.$store.commit('setisPayPopShow', true)
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // this.$router.push('/member')
              this.$store.commit('setisPayPopShow', true)
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning'
          }).then(() => {
          })

        }).finally(()=>{
          this.btnloading = false
        })
      }catch (e){

      }


    },
    ShowContinue() {
      this.$store.commit('setShow_Continue', true)
    },
    hideTooltip(item, index) {
      this.$store.commit('setRevisionWin', item.model_version1)
      this.$store.commit('setRevisionShow', false)
      localStorage.setItem('versionMod1', item.model_version1);
      localStorage.setItem('versionMod2', Date.now());
    },
    showTooltip(type) {
      this.$store.commit('setRevisionShow', type)
      if (type == false) {
        localStorage.setItem('timestamp', Date.now());
      }
    },

    // Blob 转成 File
    zhuanhuan(item, type){
      const that = this
      console.log('Blob 转成 File')
      console.log(item)
      return new Promise((resolve, reject) => {
        const canvas = this.$refs.localCanvas
        const imgRaw = new Image()
        imgRaw.crossOrigin = 'anonymous'
        imgRaw.src = item.raw_img_url

        imgRaw.onload = () => {
          try {
            const arr = []
            const w = imgRaw.width / 2
            const h = imgRaw.height / 2

            for (let i = 0; i < 4; i++) {          // 0~3 即可
              canvas.width  = w
              canvas.height = h
              const ctx = canvas.getContext('2d')
              const x = (i % 2) * w
              const y = Math.floor(i / 2) * h
              ctx.drawImage(imgRaw, x, y, w, h, 0, 0, w, h)
              arr.push(canvas.toDataURL('image/jpeg'))
            }

            const targetBase64 = arr[type - 1]
            resolve(targetBase64)   // 只把 base64 抛出去，更灵活
          } catch (e) {
            reject(e)
          }
        }
        imgRaw.onerror = err => reject(err)
      })

    },

    uploadBase64(base64, fileName = 'img.jpg') {
      console.log('uploadBase64')
      return new Promise((resolve, reject) => {   // <-- 关键
        const blob = this.dataURLtoBlob(base64)
        const file = new File([blob], fileName, { type: blob.type })
        const fd = new FormData()
        fd.append('file', file)   // 后端字段名保持一致

        this.$http.post(`${this.fileApi}/api/front/upload/?fdir=mj_iw`, fd,
            { headers: { 'Content-Type': undefined } })
            .then(res => {
              if (res.data.error === '') {
                this.captureUrl = res.data.file_full_url
                resolve(res.data)          // 成功
              } else {
                reject(res.data.error)     // 业务失败
              }
            }).catch(reject)                  // 网络失败
      })
    },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) u8arr[n] = bstr.charCodeAt(n)
      return new Blob([u8arr], { type: mime })
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.ContinueBox {
  width: 100%;
  background: white;
  padding: 0 10px;
  font-size: 14px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  position: relative;

  .ContinueHeade {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 0;
    //border-bottom: 1px dashed #999999;
    .title1 {
      font-size: 14px;
      font-weight: 700;
      color: #000;
    }

    .ContRightHeade {
      display: flex;
      font-size: 12px;

      .version-selector, .demonstration {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #cccccc;
        background: #fff;
        padding: 2px 8px;
        cursor: pointer;
        position: relative;
        z-index: 5;
        border-radius: 4px;
      }

      .version-selector {
        margin-right: 10px;
        color: #e26609;
        background: #fef9c3;
        border: 1px solid #e26609;

        .ver {
          display: flex;
          align-items: center;

          img {
            width: 12px;
            margin-left: 4px;
          }
        }

        .version-info {
          width: 132px;
          position: absolute;
          bottom: -140px;
          left: -1px;
          //height: 100px;
          //width: 100%;

          .ver_info {
            border: 1px solid #cccccc;
            background: #fff;
            padding: 0 8px;

            .ver_List {
              padding: 6px 0;
              cursor: pointer;

              &.one { // 第一个虚线
                border-bottom: 1px dashed #dddddd;
              }

              .ver_type {
                display: flex;
                align-items: center;
                margin-bottom: 4px;

                &.yes {
                  color: #e26609;
                }

                &.no {
                  color: #000;
                }

                img {
                  width: 14px;
                  margin-left: 8px;
                }
              }

              .ver_jfbox {
                color: #9e9e9e;
                display: flex;
                justify-content: space-between;
                font-size: 12px;
              }

            }
          }

          .version_btn {

            background: #e26609;
            color: white;
            text-align: center;
            padding: 10px 0;
            border-radius: 3px;
            margin-top: 1px;
            cursor: pointer;
          }
        }
      }

      .demonstration {

      }

    }
  }

  .ContinueBody {
    position: relative;
    padding: 10px 0;

    .compile {
      width: 100%;
      border-radius: 4px;
      padding: 10px;
      color: #5f6774;
      border: 1px solid #e5e7eb;
      resize: none; /* 关闭右下角的拖拽小三角 */
    }

    .beginBtn {
      //width: 100px;
      color: white;
      background: linear-gradient(to right, #fc9694, #da74c0, #b070de, #7382f8);
      padding: 5px 16px;
      border-radius: 4px;
      cursor: pointer;
      position: absolute;
      right: 10px;
      bottom: 20px;
      font-size: 12px;
    }

  }

  .top_jiant1 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: #ffffff;
    top: -5px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
  }

  //.top_jiant2 {
  //  position: absolute;
  //  width: 10px;
  //  height: 10px;
  //  background: #ffffff;
  //  top: -5px;
  //  right: 200px;
  //  transform: translateX(-50%) rotate(45deg);
  //}
}
</style>